import { POLES_SET, POLES_LOADING, POLES_LOADED, POLE_CREATED } from '../actionTypes';

const initialState = {
    poles: [],
    totalRows: 0,
    polesIsLoading: false,
    poleCreated: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case POLES_SET:
            const isPaginated = action.payload && action.payload.data !== undefined;

            return {
                ...state,
                poles: isPaginated ? action.payload.data : (action.payload || []),
                totalRows: isPaginated ? action.payload.totalRows : (action.payload ? action.payload.length : 0)
            };

        case POLES_LOADING:
            return {
                ...state,
                polesIsLoading: true,
            };

        case POLES_LOADED:
            return {
                ...state,
                polesIsLoading: false,
            };

        case POLE_CREATED:
            return {
                ...state,
                poleCreated: action.payload,
            };

        default:
            return state;
    }
};

export default reducer;